import { render, staticRenderFns } from "./Curriculum.vue?vue&type=template&id=4d846eb6&scoped=true"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"
import style0 from "./Curriculum.vue?vue&type=style&index=0&id=4d846eb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d846eb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d846eb6')) {
      api.createRecord('4d846eb6', component.options)
    } else {
      api.reload('4d846eb6', component.options)
    }
    module.hot.accept("./Curriculum.vue?vue&type=template&id=4d846eb6&scoped=true", function () {
      api.rerender('4d846eb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/Curriculum.vue"
export default component.exports